import { capitalizeFirstLetter } from './condition.utils'

/**
 * Helper function to get fracture acronym from stage code
 */
export const getFractureAcronym = (stage: string): string => {
  switch (stage) {
    case 'mesiobuccal':
      return 'MOB'
    case 'distobuccal':
      return 'DOB'
    case 'mesiolingual':
      return 'MOL'
    case 'distolingual':
      return 'DOL'
    case 'mesiopalatal':
      return 'MOP'
    case 'distopalatal':
      return 'DOP'
    case 'incisal':
      return 'I'
    case 'difl':
      return 'DIFL'
    case 'difp':
      return 'DIFP'
    case 'mifl':
      return 'MIFL'
    case 'mifp':
      return 'MIFP'
    default:
      return stage
  }
}

/**
 * Helper function to get full fracture name from stage code
 */
export const getFractureFullName = (stage: string): string => {
  switch (stage) {
    case 'mesiobuccal':
      return 'Mesial Occlusal Buccal'
    case 'distobuccal':
      return 'Distal Occlusal Buccal'
    case 'mesiolingual':
      return 'Mesial Occlusal Lingual'
    case 'distolingual':
      return 'Distal Occlusal Lingual'
    case 'mesiopalatal':
      return 'Mesial Occlusal Palatal'
    case 'distopalatal':
      return 'Distal Occlusal Palatal'
    case 'incisal':
      return 'Incisal'
    case 'difl':
      return 'Distal Incisal Facial Lingual'
    case 'difp':
      return 'Distal Incisal Facial Palatal'
    case 'mifl':
      return 'Mesial Incisal Facial Lingual'
    case 'mifp':
      return 'Mesial Incisal Facial Palatal'
    default:
      return stage
        .replace('_', ' ')
        .split(' ')
        .map((word) => capitalizeFirstLetter(word))
        .join(' ')
  }
}

export const getCrackAcronym = (stage: string): string => {
  switch (stage) {
    case 'vertical_root':
      return 'Rt-V'
    case 'horizontal_root':
      return 'Rt-H'
    case 'vertical_crown_buccal':
      return 'VCr-B'
    case 'vertical_crown_lingual':
      return 'VCr-L'
    case 'vertical_crown_palatal':
      return 'VCr-P'
    case 'vertical_crown_occlusal':
      return 'VCr-O'
    case 'horizontal_crown_buccal':
      return 'HCr-B'
    case 'horizontal_crown_lingual':
      return 'HCr-L'
    case 'horizontal_crown_palatal':
      return 'HCr-P'
    case 'horizontal_crown_occlusal':
      return 'HCr-O'
    default:
      return stage
  }
}

export const getCrackFullName = (stage: string): string => {
  switch (stage) {
    case 'vertical_root':
      return 'Vertical Root'
    case 'horizontal_root':
      return 'Horizontal Root'
    case 'vertical_crown_buccal':
      return 'Vertical Crown Buccal'
    case 'vertical_crown_lingual':
      return 'Vertical Crown Lingual'
    case 'vertical_crown_palatal':
      return 'Vertical Crown Palatal'
    case 'vertical_crown_occlusal':
      return 'Vertical Crown Occlusal'
    case 'horizontal_crown_buccal':
      return 'Horizontal Crown Buccal'
    case 'horizontal_crown_lingual':
      return 'Horizontal Crown Lingual'
    case 'horizontal_crown_palatal':
      return 'Horizontal Crown Palatal'
    case 'horizontal_crown_occlusal':
      return 'Horizontal Crown Occlusal'
    default:
      return stage
        .replace('_', ' ')
        .split(' ')
        .map((word) => capitalizeFirstLetter(word))
        .join(' ')
  }
}
